import { z } from "zod";

import {
  systemFields,
  zReasoning,
  zTransliterations,
} from "@/lib/zod/show-fragments";

/** Read-only view schema for the Show Genres show page — full ShowGenreDbDto. */
export const showGenreViewSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    slug: z.string().nullish(),
    about: z.string().nullish(),
    aliases: z.array(z.string()).nullish(),
    parents: z.array(z.string()).nullish(),
    sections: z.array(z.string()).nullish(),
    transliterations: zTransliterations.nullish(),
    externalIds: z.any().nullish(),
    enrichmentStatus: z.string().nullish(),
    enrichment: z
      .object({
        reasoning: zReasoning.nullish(),
        features: z.record(z.string(), z.unknown()).nullish(),
        about: z.string().nullish(),
        aliases: z.array(z.string()).nullish(),
        parents: z.array(z.string()).nullish(),
        transliterations: zTransliterations.nullish(),
      })
      .passthrough()
      .nullish(),
    ...systemFields,
  })
  .passthrough();

export type ShowGenreViewType = z.infer<typeof showGenreViewSchema>;
